export function sumUtxoValue(utxos) {
    if (utxos.length > 0) {
        const balanceArray = utxos.map((o) => {
            return o.satoshis;
        });
        const balance = balanceArray.reduce((a, b) => a + b, 0);
        return balance;
    }
    else {
        return 0;
    }
}
export function sumTokenAmounts(utxos, tokenId) {
    if (utxos.length > 0) {
        const tokenArray = utxos
            .filter((utxo) => utxo.token?.tokenId === tokenId)
            .map((o) => {
            return o.token?.amount || 0n;
        });
        const balance = tokenArray.reduce((a, b) => a + b, 0n);
        return balance;
    }
    else {
        return 0n;
    }
}
//# sourceMappingURL=sumUtxoValue.js.map